import { useEffect, useState } from 'react'
import Loader from 'react-loaders'

import AnimatedLetters from '../AnimatedLetters'
import './index.scss'

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['A', 'b', 'o', 'u', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p>
            I'm a very ambitious front-end developer looking for a role in
            an established IT company with the opportunity to work with the latest
            technologies on challenging and diverse projects.
          </p>
          <p>
            Coding is my hobby and my job. I code in the 
            best way I'm able to, keeping code clean, readable, with meaningful 
            tests, and split into small pieces that make sense.
          </p>
          <p>
            If I need to define myself in one sentence, that would be a family
            person, a sports fanatic, cooking enthusiast, and tech-obsessed!!!
          </p>
        </div>
      </div>
      <Loader type="triangle-skew-spin" />
    </>
  )
}

export default About